export function formatNumber(number: number) {
	const formatter = new Intl.NumberFormat(undefined, {
		style: 'decimal',
		minimumFractionDigits: 0,
		maximumFractionDigits: 2,
	});
	return formatter.format(number);
}

export function formatCurrency(number: number, currency?: string | null) {
	const formatter = new Intl.NumberFormat(undefined, {
		style: 'currency',
		currency: currency ?? 'USD',
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	});
	return formatter.format(number);
}
